// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as MmiDivIcons$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/map-my-India/presentation/view/MmiDivIcons.bs.js";

function getLegendComp(status, icon) {
  return React.createElement("div", {
              className: "individual-status"
            }, icon, React.createElement("div", {
                  className: "status"
                }, status));
}

function LegendComponent(Props) {
  return React.createElement("div", {
              className: "legend-container"
            }, React.createElement("div", {
                  className: "status-container"
                }, getLegendComp("Trip Accepted", React.createElement(MmiDivIcons$Catalyst.AcceptTrip.make, {})), getLegendComp("Trip Started", React.createElement(MmiDivIcons$Catalyst.StartTrip.make, {})), getLegendComp("Pickup Location", React.createElement(MmiDivIcons$Catalyst.PickupLocation.make, {})), getLegendComp("Drop Location", React.createElement(MmiDivIcons$Catalyst.DropLocation.make, {})), getLegendComp("Trip End", React.createElement(MmiDivIcons$Catalyst.EndTrip.make, {})), getLegendComp("Waiting Points", React.createElement(MmiDivIcons$Catalyst.Waypoint.make, {
                          waypoint: "1"
                        })), getLegendComp("Cancelled", React.createElement(MmiDivIcons$Catalyst.CancelTrip.make, {}))));
}

var make = LegendComponent;

export {
  getLegendComp ,
  make ,
  
}
/* react Not a pure module */
